import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

export const AddressForInvoiceCheckboxWrapper = styled.div`
  border-top: 1px solid ${getThemeColor('bluegrey.90')};
  border-bottom: 1px solid ${getThemeColor('bluegrey.90')};
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)};
`;
